import { render, staticRenderFns } from "./ProjectMembersModal.vue?vue&type=template&id=60717f24&"
import script from "./ProjectMembersModal.vue?vue&type=script&lang=js&"
export * from "./ProjectMembersModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports